const regex = {
    email: /^[a-z0-9][a-z0-9.\-_]+@[a-z0-9.\-_]+\.[a-z0-9]{1,}$/i,
    password: /^[^\s]{6,}[^\s]$/
};


export default regex;
